export const Get_Dashboard_Data_Request = 'Get_Dashboard_Data_Request';
export const Add_Customer_Data_Success = "Add_Customer_Data_Success";
export const Mobile_OTP_Request = "Mobile_OTP_Request";
export const Mobile_OTP_Verification_Request =
  "Mobile_OTP_Verification_Request";
  export const proposalDetails = "proposalDetails";
  export const MemberDetails = "MemberDetails";
  export const NomineeDetails = "NomineeDetails";
  export const MedcalData = "MedcalData";